import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadGroups } from './actions'
import { toggleGroupStack } from '../../../../../GroupStack/actions'

const mapStateToProps = (state) => ({
    loading: state.getIn(['ui', 'entityStack', 'groups', 'loading']),
    loaded: state.getIn(['ui', 'entityStack', 'groups', 'loaded']),
    groupsCollection: state.getIn(['ui', 'entityStack', 'groups', 'groups']),
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            toggleGroupStack,
            loadGroups,
        },
        dispatch
    )

export default (GroupContentComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            groupsCollection: IPropTypes.list.isRequired,
            loaded: PropTypes.bool.isRequired,
            loadGroups: PropTypes.func.isRequired,
            loading: PropTypes.bool.isRequired,
            toggleGroupStack: PropTypes.func.isRequired,
        }

        render() {
            return <GroupContentComponent {...this.props} />
        }
    }

    return HocConnect
}
